function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.is-array.js";
import { z } from 'zod';
import { FormDefinition } from "../components/DynamicForm";
import { filterByTypes, findByType } from "../data";
export var requirementStatuses = ['preparing', 'missing', 'rejected', 'reviewing', 'approved', 'inactive'];
export var RequirementStatus = z["enum"](requirementStatuses);
export var requirementStates = ['required', 'optional', 'earlyAccess'];
export var RequirementState = z["enum"](requirementStates);
export var Decision = z.union([z.object({
  type: z.literal('overall'),
  status: z.union([z.literal('rejected'), z.literal('approved')]),
  reason: z.string().nullish(),
  reasonAdditionalNote: z.string().nullish()
}), z.object({
  type: z.literal('per_item'),
  item: z.string(),
  status: z.union([z.literal('rejected'), z.literal('approved')]),
  reason: z.string().nullish(),
  reasonAdditionalNote: z.string().nullish()
})]);
export var Check = z.union([z.object({
  type: z.literal('overall'),
  checkCode: z.string(),
  resultCode: z.string(),
  resultDescription: z.string().nullish(),
  humanFeedback: z.string().array().nullish()
}), z.object({
  type: z.literal('per_item'),
  item: z.string(),
  checkCode: z.string(),
  resultCode: z.string(),
  resultDescription: z.string().nullish(),
  humanFeedback: z.string().array().nullish()
})]);
var AnswersHistory = z.object({
  timestamp: z.string(),
  submitted: z["boolean"](),
  evaluatedAt: z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/).nullish(),
  evaluatedBy: z.union([z.literal('applyboard_support_team'), z.literal('applyboard_automation')]).nullish(),
  submittedAt: z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/).nullish(),
  submittedBy: z.union([z.literal('applicant'), z.literal('applyboard_support_team'), z.literal('applyboard_requirement_synchronization')]).nullish(),
  answers: z.array(z.object({
    key: z.string(),
    value: z.union([z.string(), z["boolean"](), z.array(z.string())]),
    decisions: z.array(Decision
    // TODO: Add this back when BE team debugs root cause of the issue
    // See: https://applyboard.slack.com/archives/C02F4DWK99U/p1726671878484569?thread_ts=1726495648.405099&cid=C02F4DWK99U
    // .refine(
    //   data =>
    //     data.status === 'approved' ||
    //     (data.status === 'rejected' && data.reason !== undefined && data.reason !== null),
    //   {
    //     message: 'reason is required when status is "rejected"',
    //     path: ['reason'],
    //   },
    // )
    // .refine(
    //   data =>
    //     data.status === 'approved' ||
    //     (data.status === 'rejected' &&
    //       data.reasonAdditionalNote !== undefined &&
    //       data.reasonAdditionalNote !== null),
    //   {
    //     message: 'reasonAdditionalNote is required when status is "rejected"',
    //     path: ['reasonAdditionalNote'],
    //   },
    // ),
    ),
    checks: z.array(Check).nullish()
  }))
});
var requirementApplicationStages = ['pre-payment', 'pre-submission', 'submission', 'post-submission', 'admission', 'visa-application', 'post-decision', 'deferral', 'pre-arrival', 'arrival', 'refund', 'general', 'finish-deferral', 'cancellation'];
export var RequirementApplicationStage = z["enum"](requirementApplicationStages);
var UserAttachment = z.object({
  // TODO: there is a BE defect where id is coming back as a number; remove when fixed - https://applyboard.slack.com/archives/C04PKSZ1F39/p1717089141959839
  // this will be fixed in AWA-5282
  id: z.union([z.string(), z.number()]).transform(function (value) {
    return value.toString();
  }),
  name: z.string(),
  contentType: z["enum"](['application/msword', 'application/octet-stream', 'application/pdf', 'application/x-zip-compressed', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/png', 'image/jpeg', 'image/gif', 'text/plain', 'video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-flv', 'video/x-ms-wmv']),
  size: z.number(),
  downloadLink: z.string(),
  deleted: z["boolean"]().nullish(),
  deletionReason: z.literal('pii').nullish(),
  validation: z.object({
    status: z.union([z.literal('in_progress'), z.literal('pending'),
    // 'enqueued' is basically the same thing as 'pending'
    // See: https://applyboard.slack.com/archives/C06ME2XT59V/p1729094529894119
    z.literal('enqueued').transform(function () {
      return 'pending';
    }), z.literal('done'), z.literal('failed')])
    // TODO: remove this workaround for null status once BE is fixed - https://applyboard.slack.com/archives/C04PKSZ1F39/p1717130096544059
    // will be fixed in https://applyboard.atlassian.net/browse/AWA-5283
    .nullable(),
    estimatedTime: z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/).nullable(),
    results: z.array(z.object({
      code: z.union([z.literal('warning'), z.literal('negative'), z.literal('positive')]),
      message: z.string()
    }))
  }).nullable()
  // TODO: remove this workaround for null status once BE is fixed - https://applyboard.slack.com/archives/C04PKSZ1F39/p1717130096544059
  // will be fixed in https://applyboard.atlassian.net/browse/AWA-5283
  .transform(function (value) {
    return !(value !== null && value !== void 0 && value.status) ? null : value;
  })
}).refine(function (data) {
  return !(data.deleted === true && data.deletionReason !== 'pii');
}, {
  message: "If 'deleted' is true, 'deletionReason' must be 'pii'",
  path: ['deletionReason']
}).refine(function (data) {
  return !(data.deleted !== true && data.deletionReason !== undefined);
}, {
  message: "If 'deleted' is false, 'undefined', or 'null', 'deletionReason' must be 'undefined'",
  path: ['deletionReason']
});
export var RequirementAction = z["enum"](['submit', 'approve', 'reject', 'restart_review', 'edit']);
var MutableAttributeName = z["enum"](['answers.decisions', 'classification', 'deadline', 'description', 'flags.active', 'flags.optional', 'internal_description', 'internal_title', 'supplemental_links', 'title']);
var MutableAttributes = z.unknown().array().transform(function (attributes) {
  return attributes.filter(function (attribute) {
    return _typeof(attribute) === 'object' && attribute && 'name' in attribute && MutableAttributeName.safeParse(attribute.name).success;
  });
}).pipe(z.array(z.discriminatedUnion('name', [z.object({
  name: MutableAttributeName
})])));
export var EditRequirementAction = z.object({
  id: z.literal(RequirementAction.Values.edit),
  additionalInformation: z.object({
    mutableAttributes: MutableAttributes
  }).nullish()
});
var AvailableActions = z.unknown().array().transform(function (actions) {
  return actions.filter(function (action) {
    return _typeof(action) === 'object' && action && 'id' in action && RequirementAction.safeParse(action.id).success;
  });
}).pipe(z.array(z.discriminatedUnion('id', [z.object({
  id: z["enum"]([RequirementAction.Values.submit, RequirementAction.Values.approve, RequirementAction.Values.reject, RequirementAction.Values.restart_review])
}), EditRequirementAction]))).nullish();
export var ApplicationRequirementAttributes = z.object({
  legacyId: z.number(),
  applicationStage: RequirementApplicationStage.nullish(),
  category: z.string().nullish(),
  classification: z.union([z.literal('applicant_requirement'), z.literal('action_requirement'), z.literal('school_requirement')]),
  deadline: z.string().nullish(),
  description: z.string(),
  estimatedTimeUntilPrepared: z.string().nullish(),
  etag: z.string(),
  flags: z.object({
    active: z["boolean"](),
    applyboardRequirement: z["boolean"](),
    earlyAccess: z["boolean"](),
    manual: z["boolean"]().optional(),
    modified: z["boolean"]().optional(),
    optional: z["boolean"](),
    requiredBeforePayment: z["boolean"]().nullish()
  }),
  // TODO: remove this check when formDefinition on all requirements
  formDefinition: FormDefinition.nullable().transform(function (value) {
    return value === null ? {
      components: []
    } : value;
  }),
  internalDescription: z.string().nullish(),
  internalTitle: z.string().nullish(),
  requirementTemplateId: z.string().nullish(),
  // TODO: can remove the optional once BE
  // https://applyboard.atlassian.net/browse/AWA-5459 is deployed
  requirementTemplateNumber: z.string().nullish(),
  responses: z.object({
    answersHistory: z.array(AnswersHistory).optional(),
    attachments: z.array(UserAttachment).optional()
  }).optional(),
  status: RequirementStatus,
  supplementalLinks: z.array(z.string()).optional(),
  supplementalAttachments: z.array(z.object({
    fileName: z.string(),
    fileSize: z.number(),
    fileDownloadLink: z.string()
  })).optional(),
  title: z.string(),
  availableActions: AvailableActions
}).transform(function (requirement) {
  if (!requirement.flags.active) {
    return _objectSpread(_objectSpread({}, requirement), {}, {
      status: 'inactive'
    });
  }
  return requirement;
});
export var applicationRequirementTypes = ['application_disclaimer_requirement', 'application_document_requirement', 'application_hybrid_requirement', 'application_payment_requirement', 'application_questions_requirement', 'application_receipt_requirement'];
var ApplicationRequirementTypes = z["enum"](applicationRequirementTypes);
export var ApplicationRequirementResponse = z.object({
  attributes: ApplicationRequirementAttributes,
  id: z.string(),
  type: ApplicationRequirementTypes
});
export function validateChecksMatchDefinitions(data, ctx) {
  var _featureFlags$attribu;
  var evaluationMetadata = findByType(data, 'evaluation_metadata');
  var requirements = filterByTypes(data, applicationRequirementTypes);
  var featureFlags = findByType(data, 'feature_flags');
  if (!(featureFlags !== null && featureFlags !== void 0 && (_featureFlags$attribu = featureFlags.attributes) !== null && _featureFlags$attribu !== void 0 && _featureFlags$attribu.application_apr_checks)) {
    return;
  }
  var _iterator = _createForOfIteratorHelper(requirements),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _requirement$attribut;
      var requirement = _step.value;
      var _iterator2 = _createForOfIteratorHelper(((_requirement$attribut = requirement.attributes.responses) === null || _requirement$attribut === void 0 ? void 0 : _requirement$attribut.answersHistory) || []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var answerHistory = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(answerHistory.answers),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var answer = _step3.value;
              var _iterator4 = _createForOfIteratorHelper(answer.checks || []),
                _step4;
              try {
                var _loop = function _loop() {
                    var check = _step4.value;
                    if (!evaluationMetadata) {
                      ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Some requirements have checks, but there's no evaluation metadata in the response"
                      });
                      return {
                        v: z.NEVER
                      };
                    }
                    var checkDefinition = evaluationMetadata.attributes.checkDefinitions.find(function (_ref) {
                      var code = _ref.code;
                      return code === check.checkCode;
                    });
                    if (!checkDefinition) {
                      ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Check definition not found for code '".concat(check.checkCode, "'")
                      });
                      return {
                        v: z.NEVER
                      };
                    }
                    var resultDefinition = checkDefinition.results.find(function (_ref2) {
                      var code = _ref2.code;
                      return code === check.resultCode;
                    });
                    if (!resultDefinition) {
                      ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Result definition not found for code '".concat(check.resultCode, "'")
                      });
                      return {
                        v: z.NEVER
                      };
                    }
                    var _iterator5 = _createForOfIteratorHelper(check.humanFeedback || []),
                      _step5;
                    try {
                      var _loop2 = function _loop2() {
                          var feedbackCode = _step5.value;
                          var feedbackDefinition = checkDefinition.feedbackOptions.find(function (_ref3) {
                            var code = _ref3.code;
                            return code === feedbackCode;
                          });
                          if (!feedbackDefinition) {
                            ctx.addIssue({
                              code: z.ZodIssueCode.custom,
                              message: "Feedback definition not found for code '".concat(feedbackCode, "'")
                            });
                            return {
                              v: {
                                v: z.NEVER
                              }
                            };
                          }
                        },
                        _ret2;
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        _ret2 = _loop2();
                        if (_ret2) return _ret2.v;
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                  },
                  _ret;
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _ret = _loop();
                  if (_ret) return _ret.v;
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}